(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elastica-firmness-advisor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elastica-firmness-advisor')) {
    class ElasticaFirmnessAdvisor extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const config = this.querySelector('[data-advisor-config]');
        if (!config) return;
        this.config = JSON.parse(config.textContent);
        this.dialog = this.querySelector('dialog');
        if (typeof this.dialog.showModal !== 'function') return;
        this.ready = true;
        this.hidden = false;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-open')) this.open();
          if (button.hasAttribute('data-close')) this.dialog.close();
          if (button.hasAttribute('data-calculate')) this.calculate();
          if (button.hasAttribute('data-back')) this.edit();
          if (button.hasAttribute('data-apply')) this.apply();
        });
        this.querySelectorAll('[data-weight]').forEach((input) => {
          input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              this.calculate();
            }
          });
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          this.cancelRequest();
          this.unlockScroll();
          this.querySelector('[data-open]').focus();
        });
      }

      disconnectedCallback() {
        this.cancelRequest();
        this.unlockScroll();
      }

      open() {
        this.sizeChoice = null;
        this.edit(false);
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        this.querySelector('[data-profile]').focus();
      }

      unlockScroll() {
        if (this.previousOverflow === undefined) return;
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }

      error(key) {
        const element = this.querySelector('[data-error]');
        element.textContent = key ? this.config.messages[key] : '';
        element.hidden = !key;
      }

      edit(focus = true) {
        this.cancelRequest();
        this.grade = null;
        this.error(null);
        this.querySelector('[data-title]').textContent = this.config.messages.title;
        this.querySelector('[data-intro]').hidden = false;
        this.dialog.setAttribute('aria-describedby', this.querySelector('[data-intro]').id);
        this.querySelector('[data-input]').hidden = false;
        this.querySelector('[data-result]').hidden = true;
        if (focus) this.querySelector('[data-weight]').focus();
      }

      calculate() {
        this.error(null);
        const profile = this.querySelector('[data-profile]:checked')?.value;
        const input = this.querySelector('[data-weight]');
        const rawWeight = input.value.trim().replace(',', '.');
        const weight = Number(rawWeight);
        if (!['male', 'female', 'diverse'].includes(profile)) {
          this.error('profile');
          this.querySelector('[data-profile]').focus();
          return;
        }
        if (!/^\d+(?:\.\d+)?$/.test(rawWeight) || !Number.isFinite(weight) || weight <= 0) {
          this.error('weight');
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        input.removeAttribute('aria-invalid');
        this.grade = (profile === 'male' ? weight >= 90 : weight > 90) ? 'H3' : 'H2';
        this.querySelector('[data-grade]').textContent = this.config.messages[`grade_${this.grade.toLowerCase()}`];
        this.querySelector('[data-reason]').textContent = this.config.messages[`${profile}_${this.grade.toLowerCase()}`];
        if (this.config.mode === 'reversible') {
          this.querySelector('[data-reason]').textContent += ` ${this.config.messages[`reversible_${this.grade.toLowerCase()}`]}`;
        }
        this.prepareSize();
        this.setLoading(false);
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'de', { maximumFractionDigits: 2 });
        this.querySelector('[data-summary-weight]').textContent = formatter.format(weight);
        const position = this.querySelector('[data-position]:checked')?.value;
        const positionDetails = ['back', 'side', 'stomach', 'mixed'].includes(position) ? this.config.positions[position] : null;
        this.querySelector('[data-summary-position-wrap]').hidden = !positionDetails;
        this.querySelector('[data-summary-position]').textContent = positionDetails?.label || '';
        this.querySelector('[data-position-tip]').hidden = !positionDetails;
        this.querySelector('[data-position-advice]').textContent = positionDetails?.tip || '';
        this.querySelector('[data-title]').textContent = this.config.messages.recommendation;
        this.querySelector('[data-intro]').hidden = true;
        this.dialog.removeAttribute('aria-describedby');
        this.querySelector('[data-input]').hidden = true;
        this.querySelector('[data-result]').hidden = false;
        this.querySelector('[data-result-focus]').focus();
      }

      prepareSize() {
        const target = this.config.targets?.[this.grade] || this.config;
        this.sizeOption = target.options.find((option) => ['größe', 'groesse', 'size', 'matratzengröße', 'mattress size'].includes(option.name.trim().toLowerCase()));
        this.querySelector('[data-size-field]').hidden = !this.sizeOption;
        const select = this.querySelector('[data-size]');
        select.replaceChildren();
        if (!this.sizeOption) return;
        const current = this.selection();
        const sourceIndex = this.config.options.findIndex((option) => option.name === this.sizeOption.name);
        const preferred = this.sizeChoice || current?.[sourceIndex]?.name;
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = this.config.messages.choose_size;
        select.append(placeholder);
        this.sizeOption.values.forEach((value) => {
          const option = document.createElement('option');
          option.value = value.id;
          option.textContent = value.name;
          select.append(option);
        });
        select.value = this.sizeOption.values.find((value) => value.name === preferred)?.id || '';
        select.onchange = () => {
          this.cancelRequest();
          this.error(null);
          this.sizeChoice = this.sizeOption.values.find((value) => value.id === select.value)?.name || null;
        };
      }

      selection() {
        const picker = document.getElementById(this.dataset.pickerId);
        if (!picker) return null;
        const controls = [...picker.querySelectorAll('input[type="radio"]:checked, select option:checked')];
        const selected = this.config.options.map((option) => {
          if (option.position === Number(this.dataset.firmnessPosition)) {
            return option.values.find((value) => value.name === this.dataset[this.grade.toLowerCase()]);
          }
          const matches = option.values.filter((value) => controls.some((control) => {
            if (control.dataset.optionValueId) return control.dataset.optionValueId === value.id;
            const group = control.closest('[data-option-index]');
            return group?.dataset.optionIndex === `option${option.position}` && control.value === value.name;
          }));
          return matches.length === 1 ? matches[0] : null;
        });
        return selected.every((value) => value?.id) ? selected : null;
      }

      setLoading(loading) {
        const button = this.querySelector('[data-apply]');
        if (!button) return;
        button.disabled = loading;
        const label = this.sizeOption ? (this.config.mode === 'reversible' ? 'apply_size_only' : 'apply_size') : (this.config.mode === 'reversible' ? 'understood' : 'apply');
        button.querySelector('[data-apply-label]').textContent = this.config.messages[loading ? 'loading' : label];
        this.querySelector('[data-size]').disabled = loading;
        this.querySelector('[data-result]').setAttribute('aria-busy', String(loading));
      }

      cancelRequest() {
        this.controller?.abort();
        this.controller = null;
        if (this.ready) this.setLoading(false);
      }

      navigate(url) {
        window.location.assign(url);
      }

      async apply() {
        if (!this.grade || this.controller) return;
        this.error(null);
        if (this.config.mode === 'reversible' && !this.sizeOption) {
          this.dialog.close();
          return;
        }
        const sourceSelection = this.selection();
        if (!sourceSelection) {
          this.error('selection');
          return;
        }
        const target = this.config.targets?.[this.grade] || this.config;
        const selectedSizeId = this.querySelector('[data-size]').value;
        if (this.sizeOption && !this.sizeOption.values.some((value) => value.id === selectedSizeId)) {
          this.error('choose_size');
          this.querySelector('[data-size]').focus();
          return;
        }
        const selection = target.options.map((option) => {
          if (option === this.sizeOption) return option.values.find((value) => value.id === selectedSizeId);
          const sourceIndex = this.config.options.findIndex((source) => source.name === option.name);
          return option.values.find((value) => value.name === sourceSelection[sourceIndex]?.name);
        });
        if (!selection.length || selection.length !== sourceSelection.length || selection.some((value) => !value?.id)) {
          this.error('unavailable');
          return;
        }
        const url = new URL(target.productUrl, window.location.origin);
        const currentUrl = new URL(window.location.href);
        if (url.pathname === currentUrl.pathname) url.search = currentUrl.search;
        url.searchParams.delete('variant');
        url.searchParams.delete('sections');
        url.searchParams.set('option_values', selection.map((value) => value.id).join(','));
        url.searchParams.set('section_id', this.dataset.sectionId);
        const controller = new AbortController();
        this.controller = controller;
        this.setLoading(true);
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Section request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const configs = [...html.querySelectorAll('elastica-firmness-advisor [data-advisor-config]')].map((element) => JSON.parse(element.textContent));
          const data = configs.find((item) => String(item.productId) === String(target.productId));
          if (!data) throw new Error('Advisor config missing');
          const variant = data.selectedVariant;
          if (!variant?.available || variant.options.length !== selection.length || !variant.options.every((value, index) => value === selection[index].name)) {
            this.error('unavailable');
            return;
          }
          if (this.controller !== controller || !this.isConnected || !this.dialog.open) return;
          const latestSelection = this.selection();
          if (this.querySelector('[data-size]').value !== selectedSizeId || !latestSelection || !latestSelection.every((value, index) => value.id === sourceSelection[index].id)) {
            this.error('selection');
            return;
          }
          url.searchParams.delete('section_id');
          url.searchParams.delete('option_values');
          url.searchParams.set('variant', variant.id);
          this.navigate(url.toString());
        } catch {
          if (this.controller === controller) this.error('network');
        } finally {
          clearTimeout(timeout);
          if (this.controller === controller) {
            this.controller = null;
            this.setLoading(false);
          }
        }
      }
    }
    customElements.define('elastica-firmness-advisor', ElasticaFirmnessAdvisor);
  }
  } catch(e) { console.error(e); }
})();

})();
